import clsx from 'clsx';
import { useController } from 'yet-another-react-lightbox';

import { Icon } from '@atom/mui';
import { KeyboardArrowLeftIcon, KeyboardArrowRightIcon } from '@atom/mui/icons';
import colors from '@atom/styles/colors';

import classes from './mediaLightbox.module.css';

export type MediaLightboxNavButtonProps = {
  direction: 'prev' | 'next';
};

const MediaLightboxNavButton = ({ direction }: MediaLightboxNavButtonProps) => {
  const { prev, next } = useController();

  const isPrev = direction === 'prev';

  return (
    <button
      type="button"
      className={clsx(classes.navButton, classes[direction])}
      aria-label={isPrev ? 'Previous' : 'Next'}
      onClick={() => (isPrev ? prev() : next())}
      data-cy={isPrev ? 'mediaLightboxPrevButton' : 'mediaLightboxNextButton'}
    >
      <Icon
        color={colors.neutral.black}
        icon={isPrev ? KeyboardArrowLeftIcon : KeyboardArrowRightIcon}
      />
    </button>
  );
};

export default MediaLightboxNavButton;
